// TEAMS Website - Translations
// Single unified translation file with EN/IT support

export const translations = {
  // === Navigation ===
  nav: {
    home: {
      en: "Home",
      it: "Home"
    },
    association: {
      en: "Association",
      it: "Associazione"
    },
    events: {
      en: "Events",
      it: "Eventi"
    },
    press: {
      en: "Press & Media",
      it: "Stampa & Media"
    },
    booking: {
      en: "Book Now",
      it: "Prenota Ora"
    }
  },

  // === Hero Section ===
  hero: {
    tagline: {
      en: "Teatro · Educazione · Arte · Musica · Spettacolo",
      it: "Teatro · Educazione · Arte · Musica · Spettacolo"
    },
    subtitle: {
      en: "Professional Musicians Association",
      it: "Associazione Musicisti Professionisti"
    },
    cta: {
      en: "Contact Us",
      it: "Contattaci"
    },
  },

  // === Mission & Who We Are Section ===
  mission: {
    title: {
      en: "Mission & Who We Are",
      it: "Chi siamo e qual è la nostra missione"
    },
    description: {
      en: "TEAMS brings together exceptional musicians dedicated to creating extraordinary artistic experiences through collaboration, education, and cultural exchange.",
      it: "TEAMS riunisce musicisti eccezionali dedicati a creare esperienze artistiche straordinarie attraverso la collaborazione, l'educazione e lo scambio culturale."
    },
    values: {
      versatility: {
        title: {
          en: "Versatility",
          it: "Versatilità"
        },
        description: {
          en: "Mastery across multiple genres, instruments, and performance styles",
          it: "Rigore filologico ed espressivo nell'interpretazione storicamente informata, con una profonda padronanza dei diversi linguaggi stilistici, delle prassi esecutive d'epoca e della corretta scelta strumentale per ogni periodo storico."
        }
      },
      culture: {
        title: {
          en: "Culture",
          it: "Cultura"
        },
        description: {
          en: "Deep appreciation for diverse musical traditions and contemporary innovation",
          it: "Nutriamo una profonda dedizione per i repertori antico e classico, affiancata da una costante ricerca nell'avanguardia contemporanea."
        }
      },
      collaboration: {
        title: {
          en: "Collaboration",
          it: "Collaborazione"
        },
        description: {
          en: "Creating magic through artistic partnership and collective creativity",
          it: "Generiamo sinergie straordinarie attraverso partnership artistiche di alto profilo e una progettualità collettiva e visionaria."
        }
      }
    },
    stats: {
      years: {
        en: "Years of Experience",
        it: "Anni di Esperienza"
      },
      concerts: {
        en: "Concerts Performed",
        it: "Concerti Eseguiti"
      },
      countries: {
        en: "International tours",
        it: "Tour Internazionali"
      },
      countriesPeople: {
        en: "Countries colleagues come from",
        it: "Paesi da cui provengono i colleghi"
      },
      colleaguesWeKnow: {
        en: "Musicians in collaboration",
        it: "Musicisti in collaborazione"
      },
      instruments: {
        en: "Instruments Mastered",
        it: "Strumenti Dominati"
      },
      teamMembers: {
        en: "Team Members",
        it: "Membri del Team"
      },
      languagesSpoken: {
        en: "Languages Spoken",
        it: "Lingue Parlate"
      },
      countriesRepresented: {
        en: "Countries Represented",
        it: "Paesi Rappresentati"
      }
    },
    readMore: {
      en: "Read more about the association",
      it: "Scopri di più sull'associazione"
    }
  },

  // === Activities Section ===
  activities: {
    title: {
      en: "Activities & Projects",
      it: "Progetti & Attività"
    },
    subtitle: {
      en: "Explore our most impactful artistic endeavors",
      it: "Esplora i nostri sforzi artistici più impattanti"
    },
    viewProject: {
      en: "View Project",
      it: "Vedi Progetto"
    },
    viewAll: {
      en: "View All Projects",
      it: "Vedi Tutti i Progetti"
    }
  },

  // === Events Section ===
  events: {
    title: {
      en: "Upcoming Events",
      it: "Prossimi Eventi"
    },
    subtitle: {
      en: "Join us for unforgettable musical experiences",
      it: "Unisciti a noi per esperienze musicali indimenticabili"
    },
    learnMore: {
      en: "Learn More",
      it: "Scopri di Più"
    },
    viewAll: {
      en: "View All Events",
      it: "Vedi Tutti gli Eventi"
    },
    types: {
      concert: {
        en: "Concert",
        it: "Concerto"
      },
      festival: {
        en: "Festival",
        it: "Festival"
      },
      opera: {
        en: "Opera",
        it: "Opera"
      }
    }
  },

  // === Event Detail Page ===
  eventDetail: {
    about: {
      en: "About the Event",
      subtitle: "Event information and details",
      it: "Informazioni sull'Evento"
    },
    performers: {
      en: "Performers",
      it: "Artisti"
    },
    venue: {
      en: "Venue",
      it: "Sede"
    },
    eventType: {
      en: "Event Type",
      it: "Tipo di Evento"
    },
    ticketPrice: {
      en: "Ticket Price",
      it: "Prezzo Biglietto"
    },
    bookTickets: {
      en: "Book Tickets",
      it: "Prenota Biglietti"
    },
    subtitle: {
      en: "Event information and details",
      it: "Informazioni sull'evento"
    },
    backToEvents: {
      en: "← Back to Events",
      it: "← Torna agli Eventi"
    },
    completed: {
      en: "Completed",
      it: "Completato"
    },
    descriptionNotAvailable: {
      en: "Event description not available.",
      it: "Descrizione evento non disponibile."
    },
    subtitle: {
      en: "Event information and details",
      it: "Informazioni sull'evento"
    }
  },

  // === Venues Section ===
  venues: {
    title: {
      en: "Prestigious Venues",
      it: "Sede Prestigiose"
    },
    subtitle: {
      en: "We've performed at the world's most respected concert halls and cultural institutions",
      it: "Abbiamo eseguito nelle sale da concerto e istituzioni culturali più rispettate al mondo"
    }
  },

  // === Press & Media Section ===
  press: {
    title: {
      en: "Press & Media",
      it: "Stampa & Media"
    },
    subtitle: {
      en: "What critics and audiences are saying about TEAMS",
      it: "Dicono di TEAMS critici e pubblico"
    },
    viewPress: {
      en: "View Press Kit",
      it: "Vedi Press Kit"
    }
  },

  // === Booking Section ===
  booking: {
    title: {
      en: "Book TEAMS",
      it: "Prenota TEAMS"
    },
    subtitle: {
      en: "Bring world-class music to your event",
      it: "Porta musica di classe mondiale al tuo evento"
    },
    form: {
      name: {
        en: "Name",
        it: "Nome"
      },
      email: {
        en: "Email",
        it: "Email"
      },
      phone: {
        en: "Phone",
        it: "Telefono"
      },
      eventType: {
        en: "Event Type",
        it: "Tipo di Evento"
      },
      eventDate: {
        en: "Event Date",
        it: "Data Evento"
      },
      venue: {
        en: "Venue",
        it: "Sede"
      },
      message: {
        en: "Message",
        it: "Messaggio"  
      },
      messagePlaceholder: {
        en: "Let us know what you have in mind",
        it: "Facci sapere cosa hai in mente"  
      },
      selectEventType: {
        en: "Select event type...",
        it: "Seleziona tipo di evento..."
      },
      submit: {
        en: "Send Inquiry",
        it: "Invia Richiesta"
      },
      success: {
        en: "Thank you! We'll be in touch soon.",
        it: "Grazie! Saremo presto in contatto."
      },
      error: {
        en: "Something went wrong. Please try again.",
        it: "Qualcosa è andato storto. Riprova."
      }
    },
    info: {
      whyChoose: {
        title: {
          en: "Why Choose TEAMS?",
          it: "Perché Scegliere TEAMS?"
        },
        items: [
          {
            en: "World-class musicians with diverse expertise",
            it: "Musicisti di classe mondiale con competenze diverse"
          },
          {
            en: "Customized programs tailored to your event",
            it: "Programmi personalizzati su misura per il tuo evento"
          },
          {
            en: "Professional production and management",
            it: "Produzione e gestione professionale"
          },
          {
            en: "Extensive experience across venues and event types",
            it: "Esperienza estesa tra sedi e tipi di eventi"
          }
        ]
      },
      whatToExpect: {
        title: {
          en: "What to Expect",
          it: "Cosa Aspettarsi"
        },
        items: [
          {
            en: "Personalized consultation within 48 hours",
            it: "Consultazione personalizzata entro 48 ore"
          },
          {
            en: "Detailed proposal with pricing options",
            it: "Proposta dettagliata con opzioni di prezzo"
          },
          {
            en: "Flexible scheduling and programming",
            it: "Programmazione e programmazione flessibili"
          },
          {
            en: "Full technical and logistical support",
            it: "Supporto tecnico e logistico completo"
          }
        ]
      }
    
    },
    eventTypeOptions: {
      en: [
        { value: "concert", label: "Concert" },
        { value: "festival", label: "Festival" },
        { value: "masterclass", label: "Masterclass" },
        { value: "other", label: "Other" }
      ],
      it: [
        { value: "concert", label: "Concerto" },
        { value: "festival", label: "Festival" },
        { value: "masterclass", label: "Masterclass" },
        { value: "other", label: "Altro" }
      ]
    }
  },

  // === Footer ===
  footer: {
    contact: {
      title: {
        en: "Contact",
        it: "Contatto"
      },
      email: {
        en: "Email",
        it: "Email"
      },
      phone: {
        en: "Phone",
        it: "Telefono"
      },
      address: {
        en: "Address",
        it: "Indirizzo"
      }
    },
    follow: {
      title: {
        en: "Follow Us",
        it: "Seguici"
      }
    },
    legal: {
      privacy: {
        en: "Privacy Policy",
        it: "Politica sulla Privacy"
      },
      terms: {
        en: "Terms of Service",
        it: "Termini di Servizio"
      },
      copyright: {
        en: "© 2024 TEAMS. All rights reserved.",
        it: "© 2024 TEAMS. Tutti i diritti riservati."
      }
    }
  },

  // === Association Page ===
  association: {
    hero: {
      title: {
        en: "The Association",
        it: "L'Associazione"
    },
      subtitle: {
        en: "Excellence in musical performance and education",
        it: "Eccellenza nella performance musicale e nell'educazione"
      }
    },
    mission: {
      title: {
        en: "Our Mission",
        it: "La Nostra Missione"
      },
      description: {
        en: "TEAMS is dedicated to elevating the cultural landscape through exceptional musical performances, educational initiatives, and collaborative artistic projects that bridge traditions and innovation.",
        it: "TEAMS è dedicata a elevare il panorama culturale attraverso performance musicali eccezionali, iniziative educative e progetti artistici collaborativi che collegano tradizione e innovazione."
      }
    },
    vision: {
      title: {
        en: "Our Vision",
        it: "La Nostra Visione"
      },
      description: {
        en: "We believe that music is not merely an accompaniment to life, but the very pillar of our culture. Our mission is to bridge the gap between sound and soul, cultivating a sensible ear that resonates within a sensitive heart. By exploring the depth of musical art, we strive to elevate the human experience—creating a higher standard of humanity that rises from every note and inspires us to be better.",
        it: "Crediamo che la musica non sia semplicemente un accompagnamento alla vita, ma il pilastro stesso della nostra cultura. La nostra missione è colmare il divario tra suono e anima, coltivando un orecchio sensibile che risuona in un cuore sensibile. Esplorando la profondità dell'arte musicale, ci sforziamo di elevare l'esperienza umana—creando uno standard più elevato di umanità che si eleva da ogni nota e ci ispira a essere migliori."
      }
    },
    story: {
      title: {
        en: "Our Story",
        it: "La Nostra Storia"
      },
      description: {
        en: "Founded by a collective of world-class musicians, TEAMS emerged from a shared vision of creating transformative musical experiences that transcend boundaries and inspire audiences worldwide.",
        it: "Fondata da un collettivo di musicisti di classe mondiale, TEAMS è nata da una visione condivisa di creare esperienze musicali trasformative che trascendono i confini e ispirano il pubblico mondiale."
      }
    },
    team: {
      title: {
        en: "Our Team",
        it: "Il Nostro Team"
      },
      role: {
        en: "Role",
        it: "Ruolo"
      },
      instruments: {
        en: "Instruments",
        it: "Strumenti"
      }
    },
    stats: {
      teamMembers: {
        en: "Team Members",
        it: "Membri del Team"
      },
      instruments: {
        en: "Instruments",
        it: "Strumenti"
      },
      languagesSpoken: {
        en: "Languages Spoken",
        it: "Lingue Parlate"
      },
      countriesRepresented: {
        en: "Countries Represented",
        it: "Paesi Rappresentati"
      }
    },
    cta: {
      title: {
        en: "Ready to Collaborate?",
        it: "Pronti a Collaborare?"
      },
      description: {
        en: "Together. Let's create something extraordinary.",
        it: "Insieme. Creiamo qualcosa di straordinario."
      },
      button: {
        en: "Start the Conversation",
        it: "Inizia la Conversazione"
      }
    }
  },

  // === Events Page ===
  eventsPage: {
    hero: {
      title: {
        en: "Events",
        it: "Eventi"
      },
      subtitle: {
        en: "Past performances and upcoming concerts",
        it: "Performance passate e concerti imminenti"
      }
    },
    upcoming: {
      title: {
        en: "Upcoming Events",
        it: "Prossimi Eventi"
      }
    },
    past: {
      title: {
        en: "Past Events",
        it: "Eventi Passati"
      }
    },
    noEvents: {
      title: {
        en: "No events found matching your criteria.",
        it: "Nessun evento trovato che corrisponda ai tuoi criteri."
      },
      noUpcoming: {
        en: "No upcoming events scheduled.",
        it: "Nessun evento imminente programmato."
      }
    },
    cta: {
      title: {
        en: "Want to host an event?",
        it: "Vuoi organizzare un evento?"
      },
      description: {
        en: "Let us create an unforgettable musical experience for your venue or special occasion.",
        it: "Lasciaci creare un'esperienza musicale indimenticabile per la tua sede o la tua occasione speciale."
      },
      button: {
        en: "Book Your Event",
        it: "Prenota il Tuo Evento"
      }
    }
  },

  // === Press Page ===
  pressPage: {
    hero: {
      title: {
        en: "Press & Media",
        it: "Stampa & Media"
      },
      subtitle: {
        en: "Reviews, articles, and media coverage",
        it: "Recensioni, articoli e copertura mediatica"
      }
    },
    gallery: {
      title: {
        en: "Photo",
        it: "Fotografica"
      }
    },
    videos: {
      title: {
        en: "Videos",
        it: "Video"
      }
    },
    articles: {
      title: {
        en: "Articles",
        it: "Stampa"
      },
      readMore:{
        en: "Read more",
        it: "Leggi più"  
      }
    },
    reviews: {
      title: {
        en: "Reviews",
        it: "Recensioni"
      }
    },
    venues: {
      title: {
        en: "Venues",
        it: "Sede"
      },
    },
    discography: {
      title: {
        en: "Discography",
        it: "Discografia"
      }
    },
    pressKit: {
      title: {
        en: "Press Kit",
        it: "Press Kit"
      },
      description: {
        en: "Download our comprehensive press kit including bio, photos, and technical requirements.",
        it: "Scarica il nostro press kit completo, biografia, foto e requisiti tecnici."
      },
      download: {
        en: "Download Press Kit",
        it: "Scarica Press Kit"
      },
      modal: {
        title: {
          en: "Press Kit Download",
          it: "Download Press Kit"
        },
        codePrompt: {
          en: "Please ask TEAMS to provide you with a code to download our press kit",
          it: "Chiedi a TEAMS di fornirti un codice per scaricare il nostro press kit"
        },
        codePlaceholder: {
          en: "Enter your code",
          it: "Inserisci il tuo codice"
        },
        submit: {
          en: "Submit",
          it: "Invia"
        },
        cancel: {
          en: "Cancel",
          it: "Annulla"
        },
        invalidCode: {
          en: "Invalid code. Please contact TEAMS for the correct code.",
          it: "Codice non valido. Contatta TEAMS per il codice corretto."
        },
        success: {
          en: "Code verified! You can now download the press kit:",
          it: "Codice verificato! Ora puoi scaricare il press kit:"
        },
        downloadButton: {
          en: "Download Press Kit (ZIP)",
          it: "Scarica Press Kit (ZIP)"
        },
        close: {
          en: "Close",
          it: "Chiudi"
        }
      }
    },
    cta: {
      title: {
        en: "Media Inquiries?",
        it: "Richieste dei Media?"
      },
      description: {
        en: "For press releases, interviews, or additional information, please contact our media relations team.",
        it: "Per comunicati stampa, interviste o informazioni aggiuntive, contatta il nostro team delle relazioni con i media."
      },
      button: {
        en: "Contact Us",
        it: "Contattaci"
      }
    }
  },

  // === Project Page ===
  project: {
    collaborators: {
      title: {
        en: "Collaborators",
        it: "Collaboratori"
      }
    },
    links: {
      title: {
        en: "Connect & Explore",
        it: "Connetti ed Esplora"
      },
      website: {
        en: "Website",
        it: "Sito Web"
      },
      youtube: {
        en: "YouTube",
        it: "YouTube"
      },
      spotify: {
        en: "Spotify",
        it: "Spotify"
      },
      facebook: {
        en: "Facebook",
        it: "Facebook"
      }
    },
    cta: {
      title: {
        en: "Interested in similar projects?",
        it: "Interessato a progetti simili?"
      },
      description: {
        en: "Let us create an unforgettable musical experience for your event.",
        it: "Lasciaci creare un'esperienza musicale indimenticabile per il tuo evento."
      },
      button: {
        en: "Contact Us",
        it: "Contattaci"
      }
    }
  },

  // === Privacy Policy ===
  privacy: {
    title: {
      en: "Privacy Policy",
      it: "Privacy Policy"
    },
    importantNotice: {
      en: "Important Notice:",
      it: "Avvertenza Importante:"
    },
    importantNoticeText: {
      en: "This privacy policy has been updated to comply with the latest EU privacy regulations including GDPR enforcement priorities for 2026 and the AI Act.",
      it: "Questa politica sulla privacy è stata aggiornata per conformarsi alle ultime normative UE sulla privacy, incluse le priorità di applicazione del GDPR per il 2026 e l'AI Act."
    },
    introduction: {
      title: {
        en: "1. Introduction",
        it: "1. Introduzione"
      },
      content: {
        en: "TEAMS (Theater · Education · Arts · Music · Spectacle) is a professional musicians' association based in Italy. This privacy policy explains how we collect, use, protect, and share your personal data in accordance with the EU General Data Protection Regulation (GDPR) and other applicable privacy laws.",
        it: "TEAMS (Theater · Education · Arts · Music · Spectacle) è un'associazione di musicisti professionisti con sede in Italia. Questa politica sulla privacy spiega come raccogliamo, utilizziamo, proteggiamo e condividiamo i tuoi dati personali in conformità con il Regolamento Generale sulla Protezione dei Dati (GDPR) dell'UE e altre leggi sulla privacy applicabili."
      }
    },
    dataController: {
      title: {
        en: "2. Data Controller",
        it: "2. Titolare del Trattamento"
      },
      label: {
        en: "Data Controller",
        it: "Titolare del Trattamento"
      },
      address: {
        en: "Address",
        it: "Indirizzo"
      },
      email: {
        en: "Email",
        it: "Email"
      },
      phone: {
        en: "Phone",
        it: "Telefono"
      }
    },
    dataCollection: {
      title: {
        en: "3. Personal Data We Collect",
        it: "3. Dati Personali che Raccogliamo"
      },
      important: {
        en: "Important: We do not store, save, or retain any personal data about users. All data collection is limited to contact form submissions only.",
        it: "Importante: Non memorizziamo, salviamo o tratteniamo alcun dato personale sugli utenti. Tutta la raccolta dati è limitata solo alle sottomissioni di moduli di contatto."
      },
      direct: {
        title: {
          en: "3.1 Data You Provide Directly",
          it: "3.1 Dati che Fornisci Direttamente"
        },
        contactOnly: {
          en: "Contact Forms Only: Name, email address, phone number, event details, messages",
          it: "Solo Moduli di Contatto: Nome, indirizzo email, numero di telefono, dettagli eventi, messaggi"
        },
        noAccounts: {
          en: "No User Accounts: We do not create user accounts or profiles",
          it: "Nessun Account Utente: Non creiamo account utente o profili"
        },
        noRetention: {
          en: "No Data Retention: Contact form data is processed for response purposes only",
          it: "Nessuna Ritenzione Dati: I dati dei moduli di contatto vengono elaborati solo per scopi di risposta"
        },
        noNewsletters: {
          en: "No Newsletters: We do not send newsletters or marketing communications",
          it: "Nessuna Newsletter: Non inviamo newsletter o comunicazioni di marketing"
        }
      },
      automatic: {
        title: {
          en: "3.2 Automatically Collected Data",
          it: "3.2 Dati Raccolti Automaticamente"
        },
        technical: {
          en: "Technical Data: IP address, browser type, device information, access times",
          it: "Dati Tecnici: Indirizzo IP, tipo di browser, informazioni sul dispositivo, orari di accesso"
        },
        usage: {
          en: "Usage Data: Pages visited, time spent on site, referral sources",
          it: "Dati di Utilizzo: Pagine visitate, tempo trascorso sul sito, fonti di riferimento"
        },
        cookies: {
          en: "Cookies: Session identifiers, preference settings (see Cookie Policy)",
          it: "Cookie: Identificatori di sessione, impostazioni preferenze (vedi Politica sui Cookie)"
        }
      },
      whatWeDontDo: {
        title: {
          en: "3.3 What We DON'T Do",
          it: "3.3 Cosa NON Facciamo"
        },
        noProfiles: {
          en: "No User Profiles: We do not create or maintain user profiles",
          it: "Nessun Profilo Utente: Non creiamo o manteniamo profili utente"
        },
        noStorage: {
          en: "No Data Storage: We do not store personal information in databases",
          it: "Nessun Archiviazione Dati: Non memorizziamo informazioni personali in database"
        },
        noTracking: {
          en: "No Tracking: We do not track individual users across sessions",
          it: "Nessun Tracciamento: Non tracciamo utenti individuali tra le sessioni"
        },
        noMarketing: {
          en: "No Marketing: We do not use data for marketing or advertising",
          it: "Nessun Marketing: Non utilizziamo dati per marketing o pubblicità"
        },
        noSharing: {
          en: "No Data Sharing: We do not share or sell personal data",
          it: "Nessuna Condivisione Dati: Non condividiamo o vendiamo dati personali"
        }
      }
    },
    legalBasis: {
      title: {
        en: "4. Legal Basis for Processing",
        it: "4. Base Giuridica del Trattamento"
      },
      intro: {
        en: "Since we do not store personal data, our processing is minimal and based on:",
        it: "Dato che non memorizziamo dati personali, il nostro trattamento è minimo e basato su:"
      },
      contractual: {
        en: "Contractual Necessity: To respond to your contact form inquiries and booking requests",
        it: "Necessità Contrattuale: Per rispondere alle tue richieste di modulo di contatto e prenotazione"
      },
      legitimate: {
        en: "Legitimate Interest: For website security, basic analytics, and improving user experience",
        it: "Interesse Legittimo: Per la sicurezza del sito, analisi di base e miglioramento dell'esperienza utente"
      },
      legal: {
        en: "Legal Obligation: When required by Italian or EU law",
        it: "Obbligo Legale: Quando richiesto dalla legge italiana o dell'UE"
      },
      note: {
        en: "Note:",
        it: "Nota:"
      },
      noteText: {
        en: "We do not require consent for marketing purposes as we do not engage in marketing activities.",
        it: "Non richiediamo il consenso per scopi di marketing poiché non ci occupiamo di attività di marketing."
      }
    },
    dataUsage: {
      title: {
        en: "5. How We Use Your Data",
        it: "5. Come Utilizziamo i Tuoi Dati"
      },
      intro: {
        en: "Since we do not store personal data, our data usage is limited to:",
        it: "Dato che non memorizziamo dati personali, il nostro utilizzo dei dati è limitato a:"
      },
      respond: {
        en: "Respond to your contact form inquiries and booking requests",
        it: "Rispondere alle tue richieste di modulo di contatto e prenotazione"
      },
      information: {
        en: "Provide information about TEAMS services and events",
        it: "Fornire informazioni sui servizi e eventi TEAMS"
      },
      analytics: {
        en: "Basic website analytics for improving user experience",
        it: "Analisi di base del sito per migliorare l'esperienza utente"
      },
      security: {
        en: "Ensure website security and prevent fraud",
        it: "Assicurare la sicurezza del sito e prevenire frodi"
      },
      whatWeDontUse: {
        en: "What we DON'T use your data for:",
        it: "Cosa NON usiamo i tuoi dati per:"
      },
      dontUse: {
        marketing: {
          en: "Marketing or promotional communications",
          it: "Comunicazioni di marketing o promozionali"
        },
        profiles: {
          en: "Creating user profiles or accounts",
          it: "Creare profili utente o account"
        },
        sharing: {
          en: "Sharing with third parties for marketing",
          it: "Condividere con terzi per marketing"
        },
        storage: {
          en: "Long-term data storage or analysis",
          it: "Archiviazione o analisi dati a lungo termine"
        }
      }
    },
    dataSharing: {
      title: {
        en: "6. Data Sharing and International Transfers",
        it: "6. Condivisione Dati e Trasferimenti Internazionali"
      },
      thirdParty: {
        title: {
          en: "6.1 Third-Party Service Providers",
          it: "6.1 Fornitori di Servizi Terzi"
        },
        emailjs: {
          en: "EmailJS: For processing contact form submissions (servers in EU)",
          it: "EmailJS: Per elaborare le sottomissioni di moduli di contatto (server nell'UE)"
        },
        hosting: {
          en: "Web Hosting Provider: For website hosting (servers to be determined)",
          it: "Provider di Hosting Web: Per l'hosting del sito (server da determinare)"
        },
        analytics: {
          en: "Analytics Services: For website usage analysis (if implemented)",
          it: "Servizi di Analisi: Per l'analisi dell'utilizzo del sito (se implementato)"
        }
      },
      international: {
        title: {
          en: "6.2 International Data Transfers",
          it: "6.2 Trasferimenti Internazionali di Dati"
        },
        intro: {
          en: "Your personal data is primarily processed within the European Union. If we transfer data outside the EU, we ensure adequate protection through:",
          it: "I tuoi dati personali sono principalmente elaborati nell'Unione Europea. Se trasferiamo dati al di fuori dell'UE, assicuriamo adeguate protezioni attraverso:"
        },
        scc: {
          en: "Standard Contractual Clauses (SCCs)",
          it: "Clausole Contrattuali Standard (SCC)"
        },
        adequacy: {
          en: "Adequacy decisions by the European Commission",
          it: "Decisioni di adeguatezza della Commissione Europea"
        },
        safeguards: {
          en: "Appropriate safeguards under GDPR Article 49",
          it: "Salvaguardie appropriate ai sensi dell'articolo 49 del GDPR"
        }
      }
    },
    dataRetention: {
      title: {
        en: "7. Data Retention",
        it: "7. Conservazione dei Dati"
      },
      intro: {
        en: "Since we do not store personal data, our retention policy is simple:",
        it: "Dato che non memorizziamo dati personali, la nostra politica di conservazione è semplice:"
      },
      contact: {
        en: "Contact Form Data: Processed immediately for response purposes, not stored long-term",
        it: "Dati Modulo di Contatto: Elaborati immediatamente per scopi di risposta, non memorizzati a lungo termine"
      },
      noDatabases: {
        en: "No User Databases: We do not maintain databases of personal information",
        it: "Nessun Database Utente: Non manteniamo database di informazioni personali"
      },
      analytics: {
        en: "Analytics Data: 26 months for aggregated, anonymized website statistics",
        it: "Dati Analitici: 26 mesi per statistiche aggregate e anonimizzate del sito"
      },
      logs: {
        en: "Technical Logs: 30 days for security purposes, then automatically deleted",
        it: "Log Tecnici: 30 giorni per scopi di sicurezza, poi automaticamente cancellati"
      },
      emailjsNote: {
        en: "Contact form submissions are handled by EmailJS and are not retained in our systems after processing.",
        it: "Le sottomissioni di moduli di contatto sono gestite da EmailJS e non sono conservate nei nostri sistemi dopo l'elaborazione."
      }
    },
    userRights: {
      title: {
        en: "8. Your Rights Under GDPR",
        it: "8. I Tuoi Diritti ai Sensi del GDPR"
      },
      intro: {
        en: "Since we do not store personal data, most GDPR rights have limited application:",
        it: "Dato che non memorizziamo dati personali, la maggior parte dei diritti GDPR ha applicazione limitata:"
      },
      access: {
        title: {
          en: "8.1 Right to Access",
          it: "8.1 Diritto di Accesso"
        },
        content: {
          en: "Limited application - we do not store personal data to access. Contact form submissions are processed immediately and not retained.",
          it: "Applicazione limitata - non memorizziamo dati personali a cui accedere. Le sottomissioni di moduli di contatto sono elaborate immediatamente e non conservate."
        }
      },
      rectification: {
        title: {
          en: "8.2 Right to Rectification",
          it: "8.2 Diritto di Rettifica"
        },
        content: {
          en: "Limited application - since we do not store data, there is nothing to rectify in our systems.",
          it: "Applicazione limitata - dato che non memorizziamo dati, non c'è nulla da rettificare nei nostri sistemi."
        }
      },
      erasure: {
        title: {
          en: "8.3 Right to Erasure (Right to be Forgotten)",
          it: "8.3 Diritto alla Cancellazione (Diritto all'Oblio)"
        },
        content: {
          en: "Automatically respected - we do not store personal data, so there is nothing to delete.",
          it: "Automaticamente rispettato - non memorizziamo dati personali, quindi non c'è nulla da cancellare."
        }
      },
      restriction: {
        title: {
          en: "8.4 Right to Restrict Processing",
          it: "8.4 Diritto di Limitazione del Trattamento"
        },
        content: {
          en: "Automatically respected - we only process data for immediate response to inquiries.",
          it: "Automaticamente rispettato - elaboriamo dati solo per risposta immediata alle richieste."
        }
      },
      portability: {
        title: {
          en: "8.5 Right to Data Portability",
          it: "8.5 Diritto alla Portabilità dei Dati"
        },
        content: {
          en: "Limited application - we do not store data in structured formats for export.",
          it: "Applicazione limitata - non memorizziamo dati in formati strutturati per l'esportazione."
        }
      },
      objection: {
        title: {
          en: "8.6 Right to Object",
          it: "8.6 Diritto di Opposizione"
        },
        content: {
          en: "Automatically respected - we do not process data for marketing or profiling.",
          it: "Automaticamente rispettato - non elaboriamo dati per marketing o profilazione."
        }
      },
      automated: {
        title: {
          en: "8.7 Rights Related to Automated Decision-Making",
          it: "8.7 Diritti Relativi alla Decisione Automatizzata"
        },
        content: {
          en: "Not applicable - we do not use AI systems for automated decisions about individuals.",
          it: "Non applicabile - non utilizziamo sistemi AI per decisioni automatizzate su individui."
        }
      }
    },
    exerciseRights: {
      title: {
        en: "9. How to Exercise Your Rights",
        it: "9. Come Esercitare i Tuoi Diritti"
      },
      intro: {
        en: "Since we do not store personal data, most rights are automatically respected. However, if you have concerns about your data:",
        it: "Dato che non memorizziamo dati personali, la maggior parte dei diritti è automaticamente rispettata. Tuttavia, se hai preoccupazioni sui tuoi dati:"
      },
      email: {
        en: "Email",
        it: "Email"
      },
      subject: {
        en: "Subject",
        it: "Oggetto"
      },
      subjectText: {
        en: "Data Rights Inquiry",
        it: "Richiesta Diritti Dati"
      },
      responseTime: {
        en: "Response Time",
        it: "Tempo di Risposta"
      },
      responseTimeText: {
        en: "We will respond within 30 days",
        it: "Risponderemo entro 30 giorni"
      }
    },
    cookies: {
      title: {
        en: "10. Cookies and Tracking Technologies",
        it: "10. Cookie e Tecnologie di Tracciamento"
      },
      content: {
        en: "Our website uses cookies and similar technologies. For detailed information, please see our separate Cookie Policy.",
        it: "Il nostro sito utilizza cookie e tecnologie simili. Per informazioni dettagliate, consulta la nostra separata Politica sui Cookie."
      }
    },
    security: {
      title: {
        en: "11. Security Measures",
        it: "11. Misure di Sicurezza"
      },
      intro: {
        en: "We implement appropriate technical and organizational security measures including:",
        it: "Implementiamo adeguate misure di sicurezza tecniche e organizzative tra cui:"
      },
      encryption: {
        en: "SSL/TLS encryption for data transmission",
        it: "Crittografia SSL/TLS per la trasmissione dati"
      },
      hosting: {
        en: "Secure hosting environments",
        it: "Ambienti di hosting sicuri"
      },
      updates: {
        en: "Regular security updates and monitoring",
        it: "Aggiornamenti e monitoraggi di sicurezza regolari"
      },
      access: {
        en: "Access controls and authentication systems",
        it: "Controlli di accesso e sistemi di autenticazione"
      },
      training: {
        en: "Staff training on data protection",
        it: "Formazione del personale sulla protezione dei dati"
      }
    },
    children: {
      title: {
        en: "12. Children's Privacy",
        it: "12. Privacy dei Bambini"
      },
      content: {
        en: "Our website is not intended for children under 16. We do not knowingly collect personal data from children under 16 without parental consent.",
        it: "Il nostro sito non è destinato a bambini sotto i 16 anni. Non raccogliamo consapevolmente dati personali da bambini sotto i 16 anni senza il consenso dei genitori."
      }
    },
    changes: {
      title: {
        en: "13. Changes to This Policy",
        it: "13. Modifiche a Questa Politica"
      },
      intro: {
        en: "We may update this privacy policy from time to time. We will notify you of significant changes by:",
        it: "Potremmo aggiornare questa politica sulla privacy di tanto in tanto. Ti notificheremo cambiamenti significativi tramite:"
      },
      posting: {
        en: "Posting the updated policy on our website",
        it: "Pubblicazione della politica aggiornata sul nostro sito"
      },
      email: {
        en: "Sending email notifications for major changes",
        it: "Invio di notifiche email per cambiamenti importanti"
      },
      date: {
        en: "Updating the 'Last Updated' date below",
        it: "Aggiornamento della data 'Ultimo Aggiornamento' qui sotto"
      }
    },
    complaints: {
      title: {
        en: "14. Complaints",
        it: "14. Reclami"
      },
      intro: {
        en: "If you are not satisfied with our response to your privacy concerns, you have the right to lodge a complaint with:",
        it: "Se non sei soddisfatto della nostra risposta alle tue preoccupazioni sulla privacy, hai il diritto di presentare un reclamo a:"
      },
      authority: {
        en: "Italian Data Protection Authority (Garante per la Protezione dei Dati Personali)",
        it: "Autorità Italiana per la Protezione dei Dati (Garante per la Protezione dei Dati Personali)"
      },
      website: {
        en: "Website",
        it: "Sito Web"
      },
      address: {
        en: "Address",
        it: "Indirizzo"
      }
    },
    contact: {
      title: {
        en: "15. Contact Information",
        it: "15. Informazioni di Contatto"
      },
      intro: {
        en: "For privacy questions or concerns:",
        it: "Per domande o preoccupazioni sulla privacy:"
      },
      email: {
        en: "Email",
        it: "Email"
      },
      phone: {
        en: "Phone",
        it: "Telefono"
      },
      address: {
        en: "Address",
        it: "Indirizzo"
      },
      dpo: {
        en: "Data Protection Officer",
        it: "Responsabile della Protezione dei Dati"
      },
      dpoText: {
        en: "To be appointed",
        it: "Da nominare"
      }
    },
    lastUpdated: {
      en: "Last Updated",
      it: "Ultimo Aggiornamento"
    },
    lastUpdatedDate: {
      en: "January 2026",
      it: "Gennaio 2026"
    },
    version: {
      en: "Version",
      it: "Versione"
    },
    versionText: {
      en: "GDPR 2026 Compliance Update",
      it: "Aggiornamento Conformità GDPR 2026"
    },
    nextReview: {
      en: "Next Review",
      it: "Prossima Revisione"
    },
    nextReviewDate: {
      en: "January 2027",
      it: "Gennaio 2027"
    },
    backToHome: {
      en: "← Back to Home",
      it: "← Torna alla Home"
    }
  },

  // === Terms of Service (Simplified) ===
  terms: {
    title: {
      en: "Website Terms",
      it: "Termini del Sito Web"
    },
    importantNotice: {
      en: "Simple Website Usage Terms:",
      it: "Termini di Utilizzo Semplici del Sito:"
    },
    importantNoticeText: {
      en: "These are basic terms for using our informational website. No complex legal agreements - just common sense guidelines.",
      it: "Questi sono termini di base per l'uso del nostro sito informativo. Nessun accordo legale complesso - solo linee guida di buon senso."
    },
    websiteUsage: {
      title: {
        en: "Website Usage",
        it: "Utilizzo del Sito"
      },
      content: {
        en: "Our website serves as an informational portfolio and contact platform for TEAMS musical services.",
        it: "Il nostro sito serve come portfolio informativo e piattaforma di contatto per i servizi musicali TEAMS."
      },
      informational: {
        en: "Informational purposes only - no online services or purchases",
        it: "Scopi puramente informativi - nessun servizio online o acquisti"
      },
      noGuarantee: {
        en: "No guarantee of 100% website availability",
        it: "Nessuna garanzia di disponibilità del sito al 100%"
      },
      contactOnly: {
        en: "Contact forms are for inquiries and consultation requests only",
        it: "I moduli di contatto sono solo per richieste di informazioni e consulenze"
      },
      noAccounts: {
        en: "No user accounts or registrations required",
        it: "Nessun account utente o registrazione richiesta"
      }
    },
    intellectualProperty: {
      title: {
        en: "Content & Copyright",
        it: "Contenuti e Copyright"
      },
      content: {
        en: "All website content is protected by copyright and intellectual property laws.",
        it: "Tutti i contenuti del sito sono protetti da leggi sul copyright e proprietà intellettuale."
      },
      ownership: {
        en: "TEAMS owns all website content unless otherwise stated",
        it: "TEAMS possiede tutti i contenuti del sito se non diversamente indicato"
      },
      noReproduction: {
        en: "No reproduction or distribution without permission",
        it: "Nessuna riproduzione o distribuzione senza permesso"
      },
      trademarks: {
        en: "TEAMS name and logo are registered trademarks",
        it: "Il nome e il logo TEAMS sono marchi registrati"
      }
    },
    contactForms: {
      title: {
        en: "Contact Forms",
        it: "Moduli di Contatto"
      },
      content: {
        en: "When you contact us through our website forms:",
        it: "Quando ci contatti attraverso i moduli del nostro sito:"
      },
      inquiryOnly: {
        en: "Submissions are for service inquiries only",
        it: "Le sottomissioni sono solo per richieste di servizi"
      },
      noContract: {
        en: "No binding agreement formed through form submission",
        it: "Nessun accordo vincolante formato attraverso la sottomissione del modulo"
      },
      responseTime: {
        en: "We'll respond within 3 business days",
        it: "Risponderemo entro 3 giorni lavorativi"
      }
    },
    limitations: {
      title: {
        en: "Limitations",
        it: "Limitazioni"
      },
      content: {
        en: "Please understand the following limitations:",
        it: "Per favore comprendi le seguenti limitazioni:"
      },
      asIs: {
        en: "Website provided \"as is\" without warranties",
        it: "Sito fornito \"così com'è\" senza garanzie"
      },
      noLiability: {
        en: "Not liable for damages from website use",
        it: "Non responsabili per danni derivanti dall'uso del sito"
      },
      thirdParty: {
        en: "Not responsible for third-party linked content",
        it: "Non responsabili per contenuti di terze parti linkati"
      }
    },
    privacy: {
      title: {
        en: "Privacy",
        it: "Privacy"
      },
      content: {
        en: "Your privacy is important. We only collect information through contact forms and don't store personal data.",
        it: "La tua privacy è importante. Raccogliamo informazioni solo attraverso moduli di contatto e non memorizziamo dati personali."
      },
      link: {
        en: "Read our complete Privacy Policy",
        it: "Leggi la nostra completa Politica sulla Privacy"
      }
    },
    governingLaw: {
      title: {
        en: "Governing Law",
        it: "Legge Applicabile"
      },
      content: {
        en: "These terms are governed by Italian law. Any disputes will be handled in accordance with Italian legal practice.",
        it: "Questi termini sono regolati dalla legge italiana. Qualsiasi controversia sarà gestita in conformità con la pratica legale italiana."
      }
    },
    contact: {
      title: {
        en: "Questions?",
        it: "Domande?"
      },
      email: {
        en: "Email",
        it: "Email"
      },
      phone: {
        en: "Phone",
        it: "Telefono"
      },
      address: {
        en: "Address",
        it: "Indirizzo"
      }
    },
    lastUpdated: {
      en: "Last Updated",
      it: "Ultimo Aggiornamento"
    },
    lastUpdatedDate: {
      en: "January 2026",
      it: "Gennaio 2026"
    },
    version: {
      en: "Version",
      it: "Versione"
    },
    backToHome: {
      en: "← Back to Home",
      it: "← Torna alla Home"
    }
  }
};

// Default language
export const defaultLanguage = 'it';

// Available languages
export const availableLanguages = ['en', 'it'];

// Language display names
export const languageNames = {
  en: 'English',
  it: 'Italiano'
};

// Language flags
export const languageFlags = {
  en: '🇬🇧',
  it: '🇮🇹'
};
